import React from "react";
import { Dialog, Transition, Combobox } from "@headlessui/react";
import { SearchIcon } from "@heroicons/react/solid";

const CommandPalette = ({
  openPalette,
  moduleNames,
  onChangeCommandPalette,
}) => {
  const [isOpen, setIsOpen] = React.useState(openPalette);
  var [query, setQuery] = React.useState("");

  const filteredModuleNames = query
    ? moduleNames.filter((moduleName) => {
        return (
          moduleName.name.toLowerCase().includes(query.toLowerCase()) ||
          moduleName.description.toLowerCase().includes(query.toLowerCase())
        );
      })
    : [];

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    function onKeydown(event) {
      if (event.key === "q" && (event.metaKey || event.ctrlKey)) {
        event.preventDefault();
        setIsOpen(!isOpen);
      }
    }

    window.addEventListener("keydown", onKeydown);
    return () => {
      window.removeEventListener("keydown", onKeydown);
    };
  }, [isOpen]);

  return (
    <Transition.Root
      show={isOpen}
      as={React.Fragment}
      afterLeave={() => setQuery("")}>
      <Dialog
        className='fixed z-[100] inset-0 p-4 pt-[20vh] overflow-y-auto'
        open={true}
        onClose={() => {
          setIsOpen(false);
        }}>
        <Dialog.Overlay className='fixed inset-0 bg-gray-dark/80' />
        <Combobox
          as='div'
          onChange={(index) => {
            onChangeCommandPalette(JSON.stringify(filteredModuleNames[index]));
            setIsOpen(false);
          }}
          className='relative py-2 bg-white max-w-3xl mx-auto rounded shadow-2xl ring-1 ring-yellow/5 divide-y divide-gray-100'>
          <div className='flex'>
            <SearchIcon className='w-9 h-9 text-gray-dark pl-5 pt-1' />
            <Combobox.Input
              onChange={(event) => {
                setQuery(event.target.value);
              }}
              value={query}
              className='w-full bg-white border-0 focus:ring-0 text-base rounded'
              placeholder='Spotlight Search'
            />
          </div>
          {filteredModuleNames.length > 0 ? (
            <Combobox.Options
              className='px-0 py-1 text-sm max-h-50 overflow-y-auto cursor-default'
              static>
              {filteredModuleNames.map((item, index) => (
                <Combobox.Option value={index} key={item.name}>
                  {({ active }) => (
                    <div
                      className={`px-4 py-2 ${
                        active
                          ? "font-semibold bg-yellow-50 text-yellow-dark"
                          : " text-yellow-dark bg-gray-50"
                      } `}>
                      <p>{item.name}</p>
                      <p className='text-sm text-gray-700/90'>
                        {item.description}
                      </p>
                    </div>
                  )}
                </Combobox.Option>
              ))}
            </Combobox.Options>
          ) : (
            <></>
          )}
          {query && filteredModuleNames.length === 0 && (
            <p className='px-4 py-2 font-base'>No results found</p>
          )}
        </Combobox>
      </Dialog>
    </Transition.Root>
  );
};

export default CommandPalette;
